import * as React from 'react';
import Text from 'components/commons/Text';
import { Row } from 'saladsoft-primitive';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import { Button } from 'saladsoft-primitive';
import { useParams } from 'react-router-dom';
import { useStoreWrapper } from 'stores/StoreHelper';
import { useEffect, useState } from 'react';
import { ItemType } from 'components/multiSelectContainer/types';
import { useMultiSelect } from 'components/multiSelectContainer/useMultiSelect';
import ItemBox from 'components/multiSelectContainer/ItemBox';
import ItemList from 'components/multiSelectContainer/ItemList';
import ServiceHelper from 'stores/ServiceHelper';
import { toast } from 'react-toastify';
import { useStateContext } from 'providers/usePageState';

const RecommendContainer = () => {
  const { listingId } = useParams();
  const { uiStore } = useStoreWrapper();
  const { broadcast } = useStateContext();
  const [listings, setListings] = useState<ItemType[]>([]);

  const {
    selectedItems,
    handleRemoveItems,
    handleSelectItem,
    handleClickAll,
    covertModelToItem,
    unmount,
  } = useMultiSelect<ItemType & { id: number }>(
    listings.filter((l): l is ItemType & { id: number } => l.id !== undefined),
  );

  /**
   * @description 시설에 포함된 추천 숙소 취득
   */
  const fetchListingRecommendListings = () => {
    ServiceHelper.adminListingService?.getRelatedListings1(Number(listingId)).then((res) => {
      const items = res.data.map((listing) => covertModelToItem(listing));
      setListings(items);
    });
  };

  /**
   * @description 전체 숙소 취득
   */
  const fetchListings = async () => {
    const result = await ServiceHelper.adminListingService?.getListings1({ size: 100 });
    const filteredListings = result?.data
      .map((listing) => covertModelToItem(listing))
      .filter((listing) => !listings?.some((checked) => checked.id === listing.id));
    return filteredListings as ItemType[];
  };

  const handleAddRecommendListings = async () => {
    const filteredListings = await fetchListings();
    uiStore?.modal.show({
      title: '추천한옥 추가',
      style: { width: '1200px', maxHeight: '80vh', height: '100%' },
      children: (
        <ItemList
          style={{ maxHeight: '80%', height: 'auto' }}
          items={filteredListings}
          onSaveItems={(items: ItemType[]) => {
            const mergedItems = [...items, ...listings];
            handleSave(mergedItems.map((o) => o.id ?? 0));
          }}
        />
      ),
      onConfirmed: () => {
        fetchListings();
      },
    });
  };

  const handleSave = (items: number[]) => {
    ServiceHelper?.adminListingService
      ?.saveRelations(Number(listingId), items)
      .then((res) => {
        if (res.status < 300) {
          uiStore?.modal.confirm();
          toast.success('선택된 항목을 저장하였습니다.');
          fetchListingRecommendListings();
          unmount();
        } else {
          toast.error('선택된 항목 저장에 실패하였습니다.');
        }
      })
      .finally(() => {
        broadcast({ id: 'reload', param: 'recommend' });
      });
  };

  useEffect(() => {
    if (listingId) {
      fetchListingRecommendListings();
    }
  }, [listingId]);

  return (
    <div>
      <InnerSection>
        <InnerGroup style={{ minHeight: 'unset' }}>
          <div>
            <Text type="H3" style={{ marginBottom: 10 }}>
              추천한옥(비슷한 느낌의)
            </Text>
            <Text type="H4" buttonRole="DESCRIPTION" style={{ marginBottom: 10 }}>
              하단의 추가하기 버튼을 클릭하여 추천한옥을 지정 해 주세요.
            </Text>
            <Button
              type="outlined"
              style={{ width: 150 }}
              onClick={() => handleAddRecommendListings()}
            >
              추가하기
            </Button>
          </div>
          <div style={{ width: '100%', flex: 1 }}>
            <>
              {listings.length > 0 && (
                <Row marginBottom="20px" justifyContent="flex-start" gap="10px">
                  <Button type="outlined" style={{ width: 150 }} onClick={() => handleClickAll()}>
                    {selectedItems.length === listings.length ? '전체 선택해제' : '전체선택'}
                  </Button>
                  <>
                    {selectedItems && selectedItems.length > 0 && (
                      <Button
                        type="outlined"
                        style={{ width: 150 }}
                        onClick={() => {
                          const ids = handleRemoveItems();
                          uiStore?.confirm.show({
                            title: '정말 제거하시겠습니까?',
                            onConfirmed: () => {
                              handleSave(ids);
                            },
                          });
                        }}
                      >
                        선택항목 제거하기
                      </Button>
                    )}
                  </>
                </Row>
              )}
            </>
            <Row flexWrap="wrap" width="100%" justifyContent="flex-start" gap="10px">
              {listings?.map((listing, index) => (
                <ItemBox
                  key={listing.id}
                  item={listing}
                  onSelect={(item, checked) => {
                    handleSelectItem(item as ItemType & { id: number }, checked);
                  }}
                  checked={selectedItems.some((selected) => selected.id === listing.id)}
                />
              ))}
            </Row>
          </div>
        </InnerGroup>
      </InnerSection>
    </div>
  );
};

export default RecommendContainer;
